import { render, staticRenderFns } from "./ProductReward.vue?vue&type=template&id=43a7a1f9&scoped=true&"
import script from "./ProductReward.vue?vue&type=script&lang=js&"
export * from "./ProductReward.vue?vue&type=script&lang=js&"
import style0 from "./ProductReward.vue?vue&type=style&index=0&id=43a7a1f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a7a1f9",
  null
  
)

export default component.exports